<template>
  <div v-show="loaded" class="coupon-detail" :style="{ 'width': this.$store.state.clientWidth + 'px' }">
    <img class="coupon" :src="cover | filterPicture" />

    <div class="desc">
      <div>
        <h4 style="margin: 25px 0">核销码</h4>
        <div v-if="code" class="qrcode" ref="qrCodeUrl"></div>
      </div>

      <div v-if="type !== 'VISITGIFT'">
        <h4>用户信息</h4>
        <h6>
          <span style="min-width: 70px; display: inline-block">姓名：</span>{{ name }}<br/>
          <span style="min-width: 70px; display: inline-block">手机号：</span>{{ phone }}<br/>
          <span v-if="card" style="min-width: 70px; display: inline-block">身份证后四位：</span>{{ card }}
        </h6>
      </div>

      <div v-if="rule">
        <h4>使用规则</h4>
        <h6 v-html="rule"></h6>
      </div>

      <div v-if="illustration">
        <h4>免责声明</h4>
        <h6 v-html="illustration"></h6>
      </div>

      <div v-if="detail">
        <h4>商品详情</h4>
        <h6 v-html="detail"></h6>
      </div>
    </div>
  </div>
</template>

<script>
import QRCode from 'qrcodejs2'
import { mapState } from 'vuex'

export default {
  data () {
    return {
      loaded: false,

      id: '',
      name: '',
      phone: '',
      type: '',
      card: '',
      cover: '',
      rule: '',
      illustration: '',
      detail: '',
      code: '',
    }
  },

  computed: {
    ...mapState({
      room: (state) => state.room
    })
  },

  activated () {
    document.getElementById('app').scrollIntoView()

    this.loaded = false

    this.illustration = ''
    this.rule = ''
    this.detail = ''

    this.code = null
    this.card = null

    this.$nextTick(() => this.getDetail())
  },

  methods: {
    getDetail () {
      const couponId = this.$route.params.id
      
      if (!couponId) return this.toast.fail('参数错误')

      this.toast.loading({ duration: 0, message: '', forbidClick: true })
      
      this.request({ url: '/liveReceive/detail/' + couponId, data: {}}).then(res => {
        this.toast.clear()

        const coupon = res.result
        
        this.type = coupon.type
        this.loaded = true

        if (coupon.type === 'PRIZE') {
          this.id = coupon.id
          this.cover = coupon.livePrizeDetail.imageDetail
          this.rule = coupon.livePrizeDetail.rules.replace(/\n|\r\n/g, '<br>')
          this.illustration = coupon.livePrizeDetail.illustration.replace(/\n|\r\n/g, '<br>')
          this.name = coupon.memberDetail.realName
          this.phone = coupon.memberDetail.mobile
          this.card = coupon.memberDetail.idcard
        } else {
          this.id = coupon.id
          this.cover = coupon.goodsDetail.imageDetail
          this.detail = coupon.goodsDetail.detail.replace(/\n|\r\n/g, '<br>')
          this.name = coupon.memberName
          this.phone = coupon.memberMobile
          this.card = coupon.memberIdcard
        }

        console.log(coupon.useCode)
        this.code = coupon.useCode
        this.$nextTick(() => this.generateCode())
      })
    },

    generateCode () {
      var qrcode = new QRCode(this.$refs.qrCodeUrl, {
        text: window.location.origin + '/verification/' + this.id + '-' + encodeURIComponent(this.code),
        width: 150,
        height: 150,
        colorDark: '#000000',
        colorLight: '#ffffff',
        correctLevel: QRCode.CorrectLevel.H
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.coupon-detail {
  padding: 20px 17px;
  padding-bottom: calc(3.5rem * .5625 + .8rem);
  .coupon {
    width: 100%;
  }
  .desc {
    padding: 0 10px;
    h4 {
      margin: 20px 0 10px;
      font-size: 16px;
      color: #D8323F;
    }
    h6 {
      font-size: 14px;
      line-height: 26px;
      counter-reset: #4D4D4D;
    }
    .qrcode {
      display: block;
      margin: 0 auto 20px;
      width: 150px;
    }
  }
}
</style>

<style lang="scss">
.coupon-detail {
  overflow: auto;
  -webkit-overflow-scrolling: touch;
}

.ship-form {
  .van-field {
    display: flex;
    align-items: center;
    margin-bottom: .24rem;
    padding: 0 .25rem;
    height: .8rem;
    background: #F5F5F5;
    .van-field__label {
      height: .3rem;
      font-size: .3rem;
      line-height: .3rem;
      border-right: 1px solid #EB6757;
      color: #EB6757;
    }
    .van-cell__value {
      margin-left: .25rem;
    }
  }
  .ship-btn {
    margin: .5rem auto;
    text-align: center;
    button {
      width: 4.2rem;
      height: .88rem;
      border-radius: .4rem;
      background-color: #D7313F;
    }
  }
}
</style>